import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons/faInfoCircle';
import { GREY_300 } from '@propertypal/shared/src/styles/theme';
import React, { CSSProperties, FunctionComponent } from 'react';
import FontAwesomeIcon from '../icons/FontAwesomeIcon';
import { closeTooltip, openTooltip } from '../notifications/Tooltip';
import { Body, Container, Header, Row, TextRow, Title, TitleRow } from './InfoBox.style';

interface InfoBoxRowProps {
  title: string | React.ReactNode;
  icon?: any;
  tooltip?: string;
  children: React.ReactNode;
}

interface InfoBoxProps {
  title: string | React.ReactNode;
  icon?: any;
  children?: React.ReactNode;
  containerStyle?: CSSProperties;
  sideItem?: React.ReactNode;
  className?: string;
}

const ICON_STYLE = {
  fontSize: 18,
  width: 22,
  minWidth: 22,
};

export const InfoRow: FunctionComponent<InfoBoxRowProps> = (props) => {
  return (
    <Row>
      <TitleRow>
        {props.icon && <FontAwesomeIcon icon={props.icon} style={ICON_STYLE} />}

        <p>
          <b>{props.title}:</b>
        </p>

        {props.tooltip && (
          <FontAwesomeIcon
            onMouseEnter={(e) => openTooltip(props.tooltip || '', e)}
            onMouseLeave={closeTooltip}
            icon={faInfoCircle}
            size={16}
            color={GREY_300}
            style={{ marginLeft: -6, marginBottom: -2 }}
          />
        )}
      </TitleRow>

      <TextRow>{props.children}</TextRow>
    </Row>
  );
};

export const InfoBox: FunctionComponent<InfoBoxProps> = (props) => {
  return (
    <Container className={`pp-info-box${props.className ? ` ${props.className}` : ''}`} style={props.containerStyle}>
      <Header className="pp-info-box-header">
        <Title>
          {props.icon && <FontAwesomeIcon icon={props.icon} style={ICON_STYLE} />}
          {props.title}
        </Title>

        {props.sideItem}
      </Header>

      <Body>{props.children}</Body>
    </Container>
  );
};
